module.exports = __webpack_public_path__ + "static/img/black_texture.c8da83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/textures/black_texture.png
// module id = 439
// module chunks = 1